import authAPI from '../../api/auth';
import ls from '../../library/localStorage';

export default {
  namespaced: true,
  state: {
    token: ls.get('token') || null,
    userProfile: ls.get('userProfile') || {},
    companyProfile: ls.get('companyProfile') || {},
  },
  getters: {
    isLogin: (state) => !!state.token,
    token: (state) => state.token,
  },
  mutations: {
    setLogin(state, [token, userProfile]) {
      state.token = token;
      state.userProfile = userProfile;
    },
    setLogout(state) {
      state.token = null;
      state.userProfile = null;
    },
    setCompanyProfile(state, data) {
      state.companyProfile = data;
    },
  },
  actions: {
    doLogin({ commit }, { email, password }) {
      return new Promise((resolve = () => {}, reject = () => {}) => {
        authAPI
          .login(email, password)
          .then((res) => {
            if (res.data.token && res.data.users) {
              commit('setLogin', [res.data.token, res.data.users]);
              ls.set('token', res.data.token);
              ls.set('userProfile', res.data.users);
              ls.set('companyProfile', res.data.users.company);
            }
            resolve(res);
          }).catch((err) => {
            reject(err);
          });
      });
    },
    doLogout({ commit, dispatch }) {
      return new Promise((resolve = () => {}) => {
        dispatch('workspace/clearWorkspaces', null, { root: true });
        ls.remove('token');
        ls.remove('userProfile');
        ls.remove('companyProfile');
        ls.remove('activeWs');
        ls.clear();
        commit('setLogout');
        resolve();
      });
    },
    updateCompanyProfile({ commit }, data) {
      commit('setCompanyProfile', data);
    },
    doLoginCobrand({ commit }, { token }) {
      return new Promise((resolve = () => {}, reject = () => {}) => {
        authAPI
          .login_cobrand(token)
          .then((res) => {
            if (res.data.token && res.data.users) {
              commit('setLogin', [res.data.token, res.data.users]);
              ls.set('token', res.data.token);
              ls.set('userProfile', res.data.users);
              ls.set('companyProfile', res.data.users.company);
            }
            resolve(res);
          }).catch((err) => {
            reject(err);
          });
      });
    },
  },
};
